import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="roadmap" routeLang="es" />;

export const Route = createFileRoute("/hoja-de-ruta")({
  head: () => publicToolHead("roadmap", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
